import { Link } from "react-router-dom";
import { press } from "@/data/content";
import { Eyebrow } from "./Reveal";

const DISNEY_PR = "https://www.disneyplus.com/browse/entity-6fa35fc5-00e4-400e-9529-640c064fc982";

const LOGOS = [
  ["vogue", "Vogue"], ["qeditorial", "QEditorial", "png"], ["teen-vogue", "Teen Vogue"], ["hot-magazine", "HOT Magazine", "png"], ["lofficiel", "L'OFFICIEL"], ["netflix", "Netflix"], ["disney-plus", "Disney+ — Project Runway", "svg", DISNEY_PR], ["washington-post", "The Washington Post"], ["people", "PEOPLE"], ["bbc", "BBC"],
  ["cnn-chile", "CNN"], ["business-insider", "Business Insider"], ["et", "Entertainment Tonight"],
  ["project-runway", "Project Runway", "png", DISNEY_PR], ["daily-mail", "Daily Mail"], ["fox11", "FOX 11"],
  ["yahoo", "Yahoo"], ["tatler", "Tatler Asia"],
];

const hrefFor = (slug, ext) => press.find((p) => p.logo === `/img/press/${slug}.${ext}` && p.href)?.href;

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center gap-16 sm:gap-24 pr-16 sm:pr-24" aria-hidden={hidden}>
    {LOGOS.map(([slug, name, ext = "svg", link]) => {
      const href = link ?? hrefFor(slug, ext);
      const img = (
        <img src={`/img/press/${slug}.${ext}`} alt={hidden ? "" : name} loading="lazy"
          className={`${slug === "disney-plus" ? "h-11 sm:h-14" : "h-7 sm:h-9"} w-auto max-w-[160px] object-contain grayscale opacity-60 group-hover/logo:grayscale-0 group-hover/logo:opacity-100 transition-[filter,opacity] duration-700`} />
      );
      const common = { tabIndex: hidden ? -1 : undefined, "aria-label": name, className: "group/logo shrink-0" };
      return href
        ? <a key={slug} {...common} href={href} target="_blank" rel="noreferrer" data-testid={hidden ? undefined : `featured-logo-${slug}`}>{img}</a>
        : <Link key={slug} {...common} to="/press" data-testid={hidden ? undefined : `featured-logo-${slug}`}>{img}</Link>;
    })}
  </div>
);

export const FeaturedIn = () => (
  <section data-testid="home-featured-in" className="pt-16 sm:pt-20">
    <div className="max-w-[1500px] mx-auto px-5 sm:px-10 mb-10 flex items-end justify-between gap-6">
      <Eyebrow>As featured in</Eyebrow>
      <Link to="/press" data-testid="featured-in-press-link" className="text-[12px] uppercase tracking-[0.22em] text-[var(--gold)] link-line">
        All press
      </Link>
    </div>
    <div className="relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,black_10%,black_90%,transparent)]">
      <div data-testid="featured-in-track" className="marquee-track flex w-max hover:[animation-play-state:paused]">
        <Row />
        <Row hidden />
      </div>
    </div>
  </section>
);
